module.exports = __webpack_public_path__ + "img/crear-bins.388fa5db.png";